import { useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { refundMethodsWithExtra } from '@/returns/constants'
import returnsServices from '@/returns/services/services'

const useRefundMethodExtra = ({ returnId, amount, refundMethod, skip }) => {
  const { data, loading, fetchDataCancellable } = useFetch(returnsServices.getRefundMethodExtra, {
    doInitialRequest: false,
  })

  const hasExtra = refundMethodsWithExtra.includes(refundMethod)

  useEffect(() => {
    if (hasExtra && returnId && !skip) {
      fetchDataCancellable({ returnId, refundMethod, amount }, undefined, () => {})
    }
  }, [amount, fetchDataCancellable, hasExtra, refundMethod, returnId, skip])

  return {
    loading,
    amount: hasExtra ? data?.amount : undefined,
  }
}

export default useRefundMethodExtra
